interface Props {
  name: string
  nickname?: string | null
  className?: string
}

export function MemberName({ name, nickname, className }: Props) {
  return (
    <span className={className}>
      {name}
      {nickname && <span className="font-normal text-foreground/50"> “{nickname}”</span>}
    </span>
  )
}
